import React from 'react';
import {Link} from 'react-router-dom';
import displayStyle from './style';
import corssfitThumbnail from '../../images/Courses/CourseThumbnail-Crossfit01.png';
import scuptureThumbnail from '../../images/Courses/CourseThumbnail-Sculpture01.png';
import CHWThumbnail from '../../images/Courses/CourseThumbnail-CHW01.png';
import UNPThumbnail from '../../images/Courses/CourseThumbnail-UNP01.png';

import Workout from './singleWorkout/index';

export default function WorkoutsDisplay({mt}) {
	let style = displayStyle();
	return (
		<div style={style.displayOuterContainer({mt: mt})}>
			<Workout
				name='C.C.M.R’s'
				subtext='(Crossfit)'
				routeName='ccmrs'
				thumbnail={corssfitThumbnail}
				addonClasses='col-12 col-sm-3'
			/>
			<Workout
				name='Sculpture'
				subtext='(BodyBuilding)'
				routeName='sculpture'
				thumbnail={scuptureThumbnail}
				addonClasses='col-12 col-sm-3'
			/>
			<Workout
				name='Crafty Home Workouts'
				subtext=''
				routeName='chw'
				thumbnail={CHWThumbnail}
				addonClasses='col-12 col-sm-3'
			/>
			<Workout
				name='Upcoming New Programs'
				subtext='(Coming Soon)'
				routeName='unp'
				thumbnail={UNPThumbnail}
				addonClasses='col-12 col-sm-3'
			/>
		</div>
	);
}
